export type ShouldSkipClientIpApiFetchOptions = {
  /**
   * Optional override for tests (process.env.NODE_ENV is read-only under TypeScript).
   * Production code should omit this and use the real env.
   */
  nodeEnv?: string;
};

/**
 * Whether to skip calling ipapi.co from the browser.
 * On localhost, those calls often fail (CORS) or hit rate limits (429), and they
 * add noise in the console without improving local dev.
 *
 * CI Hub (ci.unicomply.ai) also skips: Playwright runs hammer the SPA and
 * ipapi.co returns Cloudflare 429s that drown Identity/API diagnosis (build 32266).
 */
export function shouldSkipClientIpApiFetch(
  options?: ShouldSkipClientIpApiFetchOptions,
): boolean {
  if (typeof window === "undefined") {
    return true;
  }
  const h = window.location.hostname.toLowerCase();
  // CI lane only — QA/PD keep geolocation for audit/App Insights.
  if (h === "ci.unicomply.ai" || h.startsWith("ci-unicomply-hub.")) {
    return true;
  }
  const env = options?.nodeEnv ?? process.env.NODE_ENV;
  if (env === "production") {
    return false;
  }
  const isLocalHost =
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "[::1]" ||
    h.endsWith(".local");
  if (!isLocalHost) {
    return false;
  }
  return env === "development" || env === "test";
}
